import { RootState } from '@reducers';

export const selectArticleSection = (state: RootState) => state.homePageReducer.articleSection;
